import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import AddCarnivalPopup from '../conductCarnival/addCarnivalPopup';

const ConductSiteCarnival = ({ 
  carnivalList = null, 
  getCarnivalList = null, 
  match,
  history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCarnivalStatus, setCurrentcarnivalStatus] = useState('');
  const [carnivalId, setCarnivalId] = useState('');
  const [changeStatus, setChangeStatus] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);

  const Headers = [
    'Project No.',
    'Name',
    'Carnival Type',
    'Start Date',
    'End Date',
    'Status',
    'Actions',
  ];

  const { siteId } = useParams();

    useEffect(() => {
        if (getCarnivalList !== null)
        (async () => {
            setIsLoading(true);
            const updatedFilter = { ...filterData, site_id: siteId };
            setFilterData(updatedFilter);
            await getCarnivalList(updatedFilter);
            setIsLoading(false);
        })();
    }, [getCarnivalList]);

  useEffect(() => {
    const tableData = [
      'id',
      'infra_id',
      'name',
      'carnival_type',
      'start_date',
      'end_date',
      'status',
    ];

    const data =
      carnivalList?.resultSets?.length &&
      carnivalList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ( 
            (key !== 'carnival_link' && key !== 'qr_link') 
            ? { [key]: element[key] }
            : (key === 'carnival_link' && element['carnival_link'] != '') ? {[key]: <a href={element[key]} target="_blank">URL</a>} : (key === 'qr_link' && element['qr_link'] != '') ? {[key]: <a href={element[key]} target="_blank">QR</a>} : {[key]: 'Not Available'})),

            (element['status'] === 'Active') ?
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/carnival/details`,
                },
                {
                  name: 'Update Details',
                  link: `${baseUrl}/brand-activation/carnival/update`,
                },
                {
                  name: 'Create duplicate',
                  link: `${baseUrl}/brand-activation/carnival/create-duplicate`,
                },
                {
                  name: 'Change Status',
                  rowData: element,
                }
              ]
            }
            :(element['status'] === 'Hold') ?
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/carnival/details`,
                },
                {
                  name: 'Change Status',
                  rowData: element,
                }
              ]
            }:(element['status'] === 'Inactive') ?
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/carnival/details`,
                }
              ]
            }:{
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/carnival/details`,
                },
                {
                  name: 'Create duplicate',
                  link: `${baseUrl}/brand-activation/carnival/create-duplicate`,
                }
              ]
            }
        )
      );
    if (carnivalList?.resultSets?.length && data) {
      setListData(data);
      setPageCount(Math.ceil(carnivalList.total / carnivalList.per_page));
    } else {
      setListData([]);
    }
  }, [carnivalList, baseUrl]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setPageNumber(val.selected + 1);
    setIsLoading(true);
    await getCarnivalList(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getCarnivalList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };
  
  const headerBtns = () => {
    const infraId = carnivalList?.infra_id;
    return (
      <Fragment>
        {infraId ?
        <Link
          to={{
            pathname: `${baseUrl}/brand-activation/conduct-carnival/add-carnival-stage/${siteId}/${infraId}/carnival`,
          }}
          className="btn btn-primary d-md-inline-block"
        >
          Schedule Carnival/Helpdesk
          <img src={Images?.ArrowRight} alt="" />
        </Link>
        : null
        }
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
        >
          <img src={Images?.Filter} alt="" />
          <b className="site_filters" style={{width:"max-content"}}>
          {localization.showFilters}
          </b>
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title='Carnival/Helpdesk Listing'
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/site-stage/${siteId}/${carnivalList?.lead_id}`}
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={carnivalList?.resultSets}
        isId={false}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={carnivalList?.from}
        setChangeStatus={setChangeStatus}
        setCarnivalId={setCarnivalId}
        setCurrentcarnivalStatus={setCurrentcarnivalStatus}
        setProjectId={setProjectId}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      {changeStatus && <AddCarnivalPopup
        changeStatus={changeStatus}
        onClosePopup={() => setChangeStatus(false)}
        currentCarnivalStatus={currentCarnivalStatus}
        carnivalId={carnivalId}
        projectId={projectId}
        startDate={startDate}
        endDate={endDate}
        history={history}
        pageNumber={pageNumber}
        getCarnivalList={getCarnivalList}
      />}

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        carnivalFilters={true}
      />
    </Layout>
  );
}; 

ConductSiteCarnival.propTypes = {
  carnivalList: PropTypes.any,
  getCarnivalList: PropTypes.func,
  match: PropTypes.any,
};

export default ConductSiteCarnival;
